import React from 'react';
import { Helmet } from 'react-helmet';

const PageCanonicalLink = ({ link }) => <Helmet>{link && <link rel="canonical" href={link} />}</Helmet>;

export default PageCanonicalLink;
